// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Previous: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M6 .5a6 6 0 100 12 6 6 0 100-12zm2.034 7.366c-.125.666-.68 1.105-1.47 1.232V9.5a.563.563 0 01-1.125 0v-.423a6.802 6.802 0 01-.969-.264l-.145-.048a.563.563 0 01.35-1.069l.151.05c.284.095.607.202.87.239.65.092 1.18-.047 1.233-.326.042-.226-.043-.344-1.073-.616l-.203-.053c-.58-.158-1.937-.526-1.687-1.855.125-.667.682-1.105 1.472-1.23V3.5a.563.563 0 011.125 0v.4c.21.037.443.094.732.187a.563.563 0 01-.342 1.071 4.269 4.269 0 00-.652-.164c-.647-.092-1.177.047-1.23.326-.03.186-.058.33.877.582l.195.052c.802.213 2.142.567 1.891 1.912z" />
        </svg>
    );
};

export default React.memo(Previous);
